import { Modal, Button } from "antd";
import { Form, Input, Select, DatePicker, message } from "antd";
import React from "react";
import axios from "axios";
import { EditOutlined, LoadingOutlined } from "@ant-design/icons";
import moment from "moment";

const { Option } = Select;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const children = [];
const Services = {
  1: "Global Care",
  3: "Home Nursing",
  4: "Connected Care",
  5: "24/7 Doctor",
  6: "Health Manager",
  7: "EHR",
};

for (const item in Services) {
  children.push(<Option key={item}>{Services[item]}</Option>);
}

class UpdatePatientDetails extends React.Component {
  state = {
    loading: false,
    visible: false,
    selectedFile: [],
  };

  upload(e) {
    console.log(e.target.files[0]);
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  onFinish = (values) => {
    const url = `https://app02.thbglobal.com/v1/patients/${this.props.id}`;

    const data = {
      patient_first_name: values.patient_first_name,
      patient_last_name: values.patient_last_name,
      patient_email: values.patient_email,
      patient_gender: values.patient_gender,
      patient_dob: values["patient_dob"].format("YYYY-MM-DD"),
      primary_health_issue: values.primary_health_issue,
      allergies: values.allergies,
      primary_address_line_one: values.address_line_1,
      primary_address_line_two: values.address_line_2,
      patient_city: values.patient_city,
      patient_state: values.patient_state,
      patient_country: values.patient_country,
      emergency_contact_name: values.emergency_contact_name,
      emergency_contact_number: values.emergency_contact_number,
      emergency_contact_relation: values.emergency_contact_relation,
      blood_group: values.blood_group,
      insurance_company_name: values.insurance_company_name,
      insured: values.insured,
      membership_number: values.membership_number,
    };
    this.handleOk();

    axios
      .put(url, data, {
        headers: {
          "x-api-key": `Bearer ${JSON.parse(localStorage.getItem("tokens"))}`,
        },
      })
      .then((res) => {
        if (res.statusText === "OK") {
          this.setState({ loading: false, visible: false });
          message.success("Patient Details Updated");
          this.props.fetchDetails();
          this.props.fetchSubscriptionDetails();
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        message.error("Patient Data Can't Be Updated");
        console.log(err);
      });
  };

  render() {
    const { visible, loading } = this.state;
    return (
      <>
        <EditOutlined
          title="Update"
          style={{ color: "blue", cursor: "pointer", fontSize: "150%" }}
          onClick={this.showModal}
        />

        <Modal
          visible={visible}
          title="Update Record"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={1000}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
              Return
            </Button>,
          ]}
        >
          <Form
            {...layout}
            name="nest-messages"
            onFinish={(values) => this.onFinish(values)}
            validateMessages={validateMessages}
            initialValues={{
              patient_first_name: this.props.patient_first_name,
              patient_last_name: this.props.patient_last_name,
              patient_email: this.props.patient_email,
              patient_gender: this.props.patient_gender,
              patient_dob: moment(this.props.patient_dob, "YYYY/DD/MM"),
              primary_health_issue: this.props.primary_health_issue,
              allergies: this.props.allergies,
              address_line_1: this.props.address_line_1,
              address_line_2: this.props.address_line_2,
              patient_city: this.props.patient_city,
              patient_state: this.props.patient_state,
              patient_country: this.props.patient_country,
              emergency_contact_name: this.props.emergency_contact_name,
              emergency_contact_number: this.props.emergency_contact_number,
              emergency_contact_relation: this.props.emergency_contact_relation,
              blood_group: this.props.blood_group,
              insurance_company_name: this.props.insurance_company_name,
              insured: this.props.insured,
              membership_number: this.props.membership_number,
            }}
          >
            <Form.Item
              name="patient_first_name"
              label="First Name"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="patient_last_name"
              label="Last Name"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="patient_email"
              label="Email"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="patient_gender"
              label="Gender"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="patient_dob"
              label="DOB"
              // initialValue={this.props.patient_dob}
              rules={[
                {
                  type: "object",
                  required: true,
                  message: "Please Select Your DOB!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              name="primary_health_issue"
              label="Health Issues"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="allergies"
              label="allergies"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="address_line_1"
              label="Address Line 1"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="address_line_2"
              label="Address Line 2"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="patient_city"
              label="City"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="patient_state"
              label="State"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="patient_country"
              label="Country"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="emergency_contact_name"
              label="Emergency Contact Name"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="emergency_contact_number"
              label="Emergency Contact Number"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="emergency_contact_relation"
              label="Emergency Contact Relation"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="blood_group"
              label="Blood Group"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Select
                style={{ width: 120 }}
                // onChange={handleChange}
              >
                <Option key="1" value="A+">
                  A+
                </Option>
                <Option key="2" value="A-">
                  A-
                </Option>
                <Option key="3" value="B+">
                  B+
                </Option>
                <Option key="4" value="B-">
                  B-
                </Option>
                <Option key="5" value="AB+">
                  AB+
                </Option>
                <Option key="6" value="AB-">
                  AB-
                </Option>
              </Select>
              {/* <Input /> */}
            </Form.Item>

            <Form.Item
              name="insurance_company_name"
              label="Insurance Company Name"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item name="insured" label="Insured">
              <Input />
            </Form.Item>

            <Form.Item
              name="membership_number"
              label="Membership Number"
              rules={[
                {
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
              <Button type="primary" htmlType="submit">
                {loading && <LoadingOutlined />}
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  }
}

export default UpdatePatientDetails;
